import { createSelector } from "reselect"
import { forEach, indexOf } from "ramda"
import { matchPath } from "react-router"

import { ApplicationStage } from "../../pages/ExamComponentNew/constants"
import { globalizeSelectors } from "@cirrus/legacy/framework/globalize"
import { getLocation } from "@cirrus/routing/services/selectors"
import { routeTemplatesBase } from "../routeTemplates"
import { lens } from "./lens"

const getRouteData = (pathname, routeData, routeTemplatesBase) => {
  forEach((rt) => {
    let match = matchPath(pathname, { path: rt.config, exact: false })

    if (match != null) {
      if (match.isExact) {
        routeData.route = rt
        routeData.match = match
        return false
      } else if (rt.children != null) {
        getRouteData(pathname, routeData, rt.children)
      }
    }
  }, routeTemplatesBase)
}

export const getRouteBase = (pathname) => {
  let routeData = {
    route: {},
    match: {
      params: {},
    },
  }

  if (pathname == null) {
    return routeData
  }

  getRouteData(pathname, routeData, routeTemplatesBase)

  return routeData
}

export const getRoute = createSelector(
  (state) => (state.location != null ? state.location.pathname : null),
  getRouteBase,
)

export const getPrevRoute = createSelector(
  (state) => (state.prevLocation != null ? state.prevLocation.pathname : null),
  getRouteBase,
)

export const getApplicationStage = (state) => {
  let route = getRoute(state)

  let ast = route.match.params.ast
  if (ast != null) {
    if (ast === 1) {
      return ApplicationStage.beforeExam
    }
    if (ast === 2) {
      return ApplicationStage.afterExam
    }
    throw Error("Application state not supported.")
  }

  let routesBeforeExam = [
    routeTemplatesBase.confirm.id,
    routeTemplatesBase.nda.id,
    routeTemplatesBase.info.id,
    routeTemplatesBase.notReady.id,
  ]
  if (indexOf(route.route.id, routesBeforeExam) != -1) {
    return ApplicationStage.beforeExam
  }

  let routesAfterExam = [routeTemplatesBase.exam.id, routeTemplatesBase.finish.id]
  if (indexOf(route.route.id, routesAfterExam) != -1) {
    return ApplicationStage.afterExam
  }

  return null
}

export default globalizeSelectors(lens, {
  getLocation,
  getRoute,
  getPrevRoute,
  getApplicationStage,
})
